import sample from 'lodash/sample'

import firedux from '../firedux'
import store, {dispatch} from '../store'

import {
  GUESTS_ENDPOINT,
  SETTINGS_GUEST_PREFIX_ENDPOINT,
  SETTINGS_GUEST_NAMES_ENDPOINT
} from '../../config/constants'

import setCurrentGuest from '../actions/set_current_guest'

// TODO: read it from chatsettings
const getGuestName = () => new Promise((resolve, reject) => {
  Promise.all([
    firedux.ref.child(SETTINGS_GUEST_PREFIX_ENDPOINT).once('value'),
    firedux.ref.child(SETTINGS_GUEST_NAMES_ENDPOINT).once('value')
  ])
  .then((values) => {
    let guestPrefix = values[0].val() || 'Guest'
    let guestNames = values[1].val() || 'Jade, Ruby, Haze, Archibald, Topaz, Emerald, Diamond,'

    resolve(guestPrefix + ' ' + sample(guestNames.split(/\,\s+/g)))
  })
})

export const watchCurrentGuest = (uid) => {
  const ENDPOINT = `${GUESTS_ENDPOINT}/${uid}`

  firedux.ref.child(ENDPOINT).on('value', (snapshot) => {
    if (snapshot.val()) {
      dispatch(setCurrentGuest(snapshot.val()))
    }
    else {
      getGuestName().then((guestName) => {
        firedux.ref.child(ENDPOINT).set({name: guestName, uid: uid})
      })
    }
  })
}

export const unwatchCurrentGuest = () => {
  const currentGuest = store.getState().get('currentGuest')

  if (currentGuest && currentGuest.get('uid')) {
    firedux.ref.child(`${GUESTS_ENDPOINT}/${currentGuest.get('uid')}`).off()
    dispatch(setCurrentGuest(null))
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_guest.js
 **/